export function ModalSection(props){

    let modal_content = props.content;
    let modal_buttons = props.buttons;

    return (
        <>
            <div className="appModal__section">
                {modal_content}
            </div>
            <div className="appModal__buttons">
                {modal_buttons}
            </div>
        </>
    );
}
